export const formatUrlTrailing = (url: string): string =>
	url != undefined && url.match(/\/$/) ? url : url + '/';
